<template>
  <v-app>
    <v-content>
      <section class="content">
        <div class="container-fluid">
          <div class="row">

            <div class="col-12">

              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Daftar Pemasukan</h3>

                  <div class="card-tools">

                    <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah
                    </button>
                  </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body ">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">

                        <label>Bulan Pemasukan</label>
                        <v-dialog ref="dialog" v-model="modaltgl" :return-value.sync="tanggal_query" persistent
                          width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field style="margin-top:0px;padding-top:0px" v-model="tanggal_query" label=""
                              prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="tanggal_query" type="month" scrollable min="2022-08" :max="dateMax">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modaltgl = false">
                              Cancel
                            </v-btn>
                            <v-btn text color="primary" @click="ubahTanggalTampil($refs)">
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <download-excel :data="datas" :fields="json_fields"
                        :worksheet="'Pemasukan ' + getBulan(tanggal_query)"
                        :name="'Pemasukan ' + getBulan(tanggal_query) + '.xls'">
                        <button type="button" class="btn btn-sm btn-success">
                          <i class="fa fa-file-excel"></i>
                          &nbsp; Download
                        </button>
                      </download-excel>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <template>
                        <div class="row">
                          <div class="col-sm-6">

                            <div class="form-group mb-2">
                              <KantorCabang v-model="filter.kantor" label="Cabang" @input="onFilterChange"
                                class="custom-input" />
                            </div>

                            <div class="form-group mb-2">
                              <TextSearch v-model="filter.search" class="custom-input" label="Cari Nama/ID Pelanggan"
                                @input="onFilterChange" />
                            </div>
                          </div>

                        </div>
                      </template>
                    </div>
                    <div class="col-md-12 table-responsive p-0">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="tanpawrap">No</th>
                            <th class="tanpawrap">Jumlah</th>
                            <th class="tanpawrap">Kategori</th>
                            <!--th>Tanggal Pengeluaran</th-->
                            <th class="tanpawrap">Tanggal Masuk</th>
                            <th class="tanpawrap">Oleh</th>
                            <th>Keterangan</th>
                            <th>Cabang</th>
                            <th class="tanpawrap">Bukti</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="(datas)" v-for="(row, index) in datas" :key="row.id">
                            <td class="tanpawrap">{{ index + 1 }}</td>
                            <td class="tanpawrap">{{ row.jumlah | toCurrency }}</td>
                            <td class="tanpawrap">{{ row.kategori_keuangan.value }}</td>
                            <!--td>{{row.tanggal}}</td-->
                            <td class="tanpawrap">{{ row.created_at | indoDate }}</td>
                            <td class="tanpawrap">{{ row.user.name }}</td>
                            <td>{{ row.keterangan }}</td>
                            <td>{{ row.keuangan_kantor.value }}</td>
                            <td class="tanpawrap">
                              <a :href="'./' + row.url_bukti" target="_blank"
                                v-if="row.url_bukti && row.url_bukti != ''" title="Download Bukti">
                                <i class="fas fa-file" aria-hidden="true"></i>
                              </a>
                            </td>
                            <!--td><a :href="'./'+row.url_bukti" target="_blank" v-if="row.url_bukti && row.url_bukti != ''" title="Download Bukti">
                            <i class="fas fa-file" aria-hidden="true"></i>
                        </a>
                        <a href="#" @click="bukaKeteranganModal(row.keterangan)" class="ml-2" title="Lihat Keterangan">
                            <i class="fas fa-eye" aria-hidden="true"></i>
                        </a>
                      </td-->
                            <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                            <!--td>

                        <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td-->
                          </tr>
                          <tr v-if="(!datas)">

                            <td colspan="6" class="text-center">
                              <h3>Data Kosong</h3>
                            </td>
                            <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                            <!--td>

                        <a href="#" v-if="row.status == 'ditolak' || row.status == 'pending'" @click="deleteData(row.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td-->
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colspan="3">Total</th>
                            <th colspan="3">{{ this.jumlahnya | toCurrency }}</th>

                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>

                </div>
                <!-- /.card-body -->
                <!--div class="card-footer">
                  <pagination :data="datas" @pagination-change-page="getResults"></pagination>
              </div-->
              </div>
              <!-- /.card -->
            </div>
          </div>

          <!-- Modal -->
          <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Tambah Pemasukkan</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form @submit.prevent="createData()" enctype="multipart/form-data">
                  <div class="modal-body">

                    <div class="form-group">
                      <label>Kas Kantor</label>
                      <select name="kantor_id" v-model="form.kantor_id" id="kantor_id" class="form-control"
                        :class="{ 'is-invalid': adaeror['kantor_id'] }" required>
                        <option value="" selected disabled>-- PILIH KANTOR --</option>
                        <option v-for="row in kantor_list" :key="row.id"
                          :value="{ id: row.id, text: row.value, saldo: row.saldo_akhir.saldo, maksimal: parseInt(row.saldo_akhir.saldo - (parseInt(row.saldo_akhir.saldo * 10 / 100))) }"
                          :selected="row.id == form.kantor_id.id">{{ row.value }}</option>
                      </select>
                      <small v-if="adaeror['kantor_id']" class="text-danger">
                        {{ adaeror["kantor_id"].join(', ') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>Kategori Pemasukan</label>
                      <select name="kategori" v-model="form.kategori" id="kategori" class="form-control"
                        :class="{ 'is-invalid': adaeror['kategori'] }" required>
                        <option value="" selected disabled>-- PILIH KATEGORI PEMASUKAN --</option>
                        <option v-for="row in kategori_list" :key="row.id" :value="{ id: row.id, text: row.value }"
                          :selected="row.id == form.kategori.id">{{ row.value }}</option>
                      </select>
                      <small v-if="adaeror['kategori']" class="text-danger">
                        {{ adaeror["kategori"].join(', ') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-12">
                          <label>Jumlah</label>
                          <input type="number" @keydown="preventArrow($event)" v-model="form.jumlah" name="jumlah"
                            class="form-control" :class="{ 'is-invalid': adaeror['jumlah'] }" required>
                          <small v-if="adaeror['jumlah']" class="text-danger">
                            {{ adaeror["jumlah"].join(', ') }}
                          </small>
                        </div>

                      </div>
                    </div>

                    <div class="form-group">
                      <label>Keterangan</label>
                      <textarea v-model="form.keterangan" id="keterangan" name="keterangan" style="resize:none" rows="5"
                        class="form-control" :class="{ 'is-invalid': adaeror['keterangan'] }" required></textarea>
                      <small v-if="adaeror['keterangan']" class="text-danger">
                        {{ adaeror["keterangan"].join(', ') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>Upload Bukti</label>
                      <div class="custom-file">
                        <input type="file" id="file" name="file" class="custom-file-input" @change="onUploadKTP"
                          :class="{ 'is-invalid': adaeror['file'] }"
                          accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                        <label class="custom-file-label" for="file">{{ filename ? filename : 'Choose File' }}</label>
                        <small v-if="adaeror['file']" class="text-danger">
                          {{ adaeror["file"].join(', ') }}
                        </small>
                      </div>

                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Tambah!</button>
                  </div>

                </form>
              </div>
            </div>
          </div>

          <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog" aria-labelledby="KeteranganModal"
            aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title"> Keterangan Pemasukan </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="closeKeteranganModal()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      {{ tampilKet }}
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="closeKeteranganModal()">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </v-content>

  </v-app>
</template>

<script>
import KantorCabang from '../../base-components/KantorCabang.vue'
import TextSearch from '../../base-components/TextSearch.vue';
export default {
  components: {
    KantorCabang,
    TextSearch
  },
  data() {
    return {
      datas: [],
      form: new Form({
        jumlah: '',
        kategori: '',
        keterangan: '',
        kantor_id: '',
        //tanggal:'',
      }),
      kategori_list: [],
      kantor_list: [],
      filename: '',
      urlFotoKtp: '',
      file: '',
      urlFotoKtpPreview: false,
      adaeror: [],
      menu: false,
      tampilKet: '',
      modaltgl: false,
      dateMax: new Date().toISOString().substr(0, 7),
      tanggal_query: new Date().toISOString().substr(0, 7),
      tanggal_tampil: '',
      jumlahnya: 0,
      filter: {
        kantor: null,
        search: null,
      },
      json_fields: {
        "TANGGAL": {
          field: "created_at",
          callback: (value) => {
            return this.getTanggalIndo(value);
          },
        },
        "NAMA KATEGORI": "kategori_keuangan.value",
        "KAS KANTOR": "keuangan_kantor.value",
        "JUMLAH": "jumlah",
        "KETERANGAN": "keterangan",
      },
    }
  },
  methods: {
    newModal() {
      this.form.reset();
      this.adaeror = [];


      this.loadKategori();
      this.loadKantor();
      this.filename = "";
      this.file = "";
      $('#addNew').modal('show');
    },
    countJumlahnya() {
      Object.entries(this.datas).forEach(([key, val]) => { this.jumlahnya += parseFloat(val.jumlah) });
    },
    getBulan(tanggal) {
      var tgltemp = new Date(tanggal);
      var tahun = tgltemp.getFullYear();
      var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

      return (bulan[tgltemp.getMonth()] + " " + tahun);
    },
    getTanggalIndo(tanggal) {
      var tgltemp = new Date(tanggal);
      var tahun = tgltemp.getFullYear();
      var bulan = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

      return (tgltemp.getDate() + "/" + bulan[tgltemp.getMonth()] + "/" + tahun);
    },
    ubahTanggalTampil(e) {
      e.dialog.save(this.tanggal_query);
      this.loadData();
      // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
    },
    bukaKeteranganModal(id) {
      this.tampilKet = id;
      $('#KeteranganModal').modal('show');
    },
    closeKeteranganModal() {
      this.tampilKet = '';
      $('#KeteranganModal').modal('hide');
    },
    onUploadKTP(e) {
      this.filename = e.target.files[0].name;
      this.file = e.target.files[0];
      //let reader  = new FileReader();

      /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
      */
      //reader.addEventListener("load", function () {
      //    this.urlFotoKtp = reader.result;
      //    this.urlFotoKtpPreview = true;
      //}.bind(this), false);

      /*
      Check to see if the file is not empty.
      */
      if (this.file) {
        /*
            Ensure the file is an image file.
        */
        if (/\.(jpe?g|png|gif|pdf|xls|xlsx|csv|odt)$/i.test(this.filename)) {

          /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
          */
          // reader.readAsDataURL( this.form.file );
        } else {
          this.filename = "ERROR! Hanya PDF atau Image(JPEG/JPG/PNG) atau Excel (XLS/XLSX/ODT/CSV)";
          this.file = "";
          //this.urlFotoKtp = "";
          //this.urlFotoKtpPreview = false;
        }
      } else {
        this.filename = "";
        this.file = "";
        //this.urlFotoKtp = "";
        //this.urlFotoKtpPreview = false;
      }

    },
    getResults(page = 1) {

      this.$Progress.start();

      axios.get('api/keuangan/pemasukan?page=' + page).then(({ data }) => (this.datas = data.data));

      this.$Progress.finish();
    },
    loadKantor() {
      axios.get("api/kantor").then(({ data }) => (this.kantor_list = data.data.data));
    },
    loadKategori() {
      axios.get("api/keuangan/kategori_list?q=" + escape(1)).then(({ data }) => (this.kategori_list = data.data));
    },
    onFilterChange() {

      this.loadData();
    },
    loadData() {
      if (!this.$gate.isAllowed("is_keuangan")) return;

      this.jumlahnya = 0;

      const tahunpaid = this.tanggal_query.substr(0, 4);
      const bulanpaid = this.tanggal_query.substr(-2);


      axios
        .get("api/keuangan/pemasukan", {
          params: {
            tahunpaid,
            bulanpaid,
            kantor_id: this.filter.kantor?.id || null,
            search: this.filter.search || null
          },
        })
        .then(({ data }) => {
          if (data.data && data.data.length > 0) {
            this.datas = data.data;
            this.countJumlahnya();
          } else {
            this.datas = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.datas = false;
        });

      this.tanggal_tampil = this.getBulan(this.tanggal_query);
    },
    createData() {
      this.$Progress.start();
      const config = {
        headers: {
          'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
        }
      }
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('datanya', JSON.stringify(this.form));
      axios.post('api/keuangan/addPemasukan', formData, config)
        .then((data) => {
          if (data.data.success) {
            $('#addNew').modal('hide');

            Toast.fire({
              icon: 'success',
              title: data.data.message
            });
            this.$Progress.finish();
            this.loadData();
            this.adaeror = [];
            this.filename = "";
            this.file = "";
          } else {
            Toast.fire({
              icon: 'error',
              title: 'Some error occured! Please try again'
            });

            this.$Progress.fail();
          }
        })
        .catch(e => {
          this.adaeror = e.response.data.errors;
          this.$Progress.fail();
          Toast.fire({
            icon: 'error',
            title: 'Some error occured! Please try again'
          });
        })
    },
    updateData() {
      /*this.$Progress.start();
      this.form.put('api/router/'+this.form.id)
      .then((response) => {
          // success
          $('#addNew').modal('hide');
          Toast.fire({
            icon: 'success',
            title: response.data.message
          });
          this.$Progress.finish();
              //  Fire.$emit('AfterCreate');

          this.loadData();
      })
      .catch(() => {
          this.$Progress.fail();
      });
      */
    },
    deleteData(id) {
      Swal.fire({
        title: 'Yakin untuk menghapus?',
        text: "Data yang sudah diApproved tidak dapat dihapus.",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Ya, Hapus!'
      }).then((result) => {

        // Send request to the server
        if (result.value) {
          this.form.delete('api/router/' + id).then(() => {
            Swal.fire(
              'Terhapus!',
              'Data Pemasukan Berhasil Dihapus.',
              'success'
            );
            // Fire.$emit('AfterCreate');
            this.loadData();
          }).catch((data) => {
            Swal.fire("Hapus Gagal!", data.message, "warning");
          });
        }
      })
    },
    preventArrow(e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault();
      }
      if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
        e.preventDefault();
      }
      // if (!/\d/.test(event.key) && event.key !== '.') return event.preventDefault();
    },

  },
  mounted() {

  },
  created() {
    this.$Progress.start();

    this.loadData();
    this.$Progress.finish();

  }
}
</script>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tanpawrap {
  white-space: nowrap;
}
</style>